<template>
  <div class="no-data-container" :style="myStyles">
    <slot name="header" />
    <slot name="errorMessage" />
    <button v-if="withButton" @click="clearGlobalFilters">
      {{ "charts.errorMessage.resetFilters" | t }}
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    withButton: Boolean,
    height: {
      type: String,
      required: true,
    },
  },
  computed: {
    myStyles() {
      return {
        height: this.height,
      };
    },
  },
  methods: {
    ...mapActions("filters", ["clearGlobalFilters"]),
  },
};
</script>

<style scoped lang="scss">
.no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: $border-base;
  border-radius: $border-radius;
  color: $gray-400;
  text-align: center;
  background: $white;

  h1,
  h2,
  h3 {
    margin-bottom: 5px;
    font-weight: 600;
  }

  button {
    margin-top: 15px;
    padding: 4px 10px;
    border: $border-base;
    border-radius: $border-radius;
  }
}
</style>
